import dynamic from 'next/dynamic';
import { SampleOrderSuspenseFallback } from '../SampleOrderSuspenseFallback';

export const LazySampleOrder = dynamic(
  () =>
    import(/* webpackChunkName: 'SampleOrder' */ '../../SampleOrder').then((module) => ({
      default: module.SampleOrder,
    })),
  { ssr: false, loading: () => <SampleOrderSuspenseFallback /> },
);
